import { supabaseHealthStore } from "@/hooks/useSupabaseHealth";

const RESTRICTION_SIGNATURES = [
  "exceed_cached_egress_quota",
  "Service for this project is restricted",
];

/**
 * Wraps the global fetch so every Supabase request is monitored.
 * - 402 or restriction message in body => mark restricted
 * - any 2xx response from Supabase => mark healthy (auto-recovery)
 * Never throws on its own — purely observational.
 */
export const createMonitoredFetch = (): typeof fetch => {
  const baseFetch = globalThis.fetch.bind(globalThis);

  return async (input, init) => {
    const response = await baseFetch(input as RequestInfo, init);

    try {
      if (response.status === 402) {
        supabaseHealthStore.markRestricted();
      } else if (response.status >= 200 && response.status < 300) {
        supabaseHealthStore.markHealthy();
      } else if (response.status >= 400) {
        // Inspect body for the restriction signature without consuming the original response
        const cloned = response.clone();
        cloned
          .text()
          .then((text) => {
            if (RESTRICTION_SIGNATURES.some((sig) => text.includes(sig))) {
              supabaseHealthStore.markRestricted();
            }
          })
          .catch(() => {
            /* ignore */
          });
      }
    } catch {
      /* never let monitoring break the request */
    }

    return response;
  };
};
